import { Box, Loader, Text } from 'braid-design-system';
import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { usePostListingById } from 'src/hooks/usePostListing';
import type { ProductBundle } from 'src/types/productBundle';
import { isBaseListingProduct } from 'src/utils/listingProducts';
// import { MutationResult } from '@apollo/client';
// import { PostListingMutation } from 'src/generated/graphql';

export const usePaymentSuccessPostListing = (productBundle: ProductBundle) => {
  const [searchParams] = useSearchParams();
  const postListing = usePostListingById();
  const listingId = searchParams.get('listingId');

  useEffect(() => {
    if (
      typeof listingId === 'string' &&
      isBaseListingProduct(productBundle.info.productCode) &&
      postListing.status.kind === 'idle'
    ) {
      postListing.post(listingId);
    }
  }, [listingId, postListing, productBundle.info.productCode]);

  return postListing.status;
};

// Strange pattern required when using Braid's <Stack /> component
// https://seekchat.slack.com/archives/CDL5VKRHN/p1666582727602299
export const shouldRenderPostListingFeedback = (
  props: PostListingFeedbackProps,
) => props.loading || props.error || props.success;

interface PostListingFeedbackProps {
  // Temp: bring back old listings post as GraphQL implementation doesn't work
  // mutationResult: MutationResult<PostListingMutation>;
  loading: boolean;
  error: boolean;
  success: boolean;
}

export const PostListingFeedback = (props: PostListingFeedbackProps) => {
  if (props.loading) {
    return (
      <Box
        data={{ testid: 'post-listing-feedback-loader' }}
        paddingY="large"
        display="flex"
        justifyContent="center"
      >
        <Loader />
      </Box>
    );
  }

  if (props.error) {
    return (
      <Text>
        We were unable to post your ad. Please return to your dashboard and post
        your ad.
      </Text>
    );
  }

  if (props.success) {
    return <Text>Your ad is now live.</Text>;
  }

  return null;
};
